import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import jaTranslations from './locales/ja.json';
import enTranslations from './locales/en.json';
import zhTranslations from './locales/zh.json';
import koTranslations from './locales/ko.json';
import thTranslations from './locales/th.json';
import viTranslations from './locales/vi.json';
import idTranslations from './locales/id.json';

const resources = {
  ja: {
    translation: jaTranslations
  },
  en: {
    translation: enTranslations
  },
  zh: {
    translation: zhTranslations
  },
  ko: {
    translation: koTranslations
  },
  th: {
    translation: thTranslations
  },
  vi: {
    translation: viTranslations
  },
  id: {
    translation: idTranslations
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
  });

export default i18n;
